import { PinUtil } from './PinUtil';
import channelBlockedUtil from "../../utils/ChannelBlockedUtil";
import BlockedChannels from "../../utils/BlockedChannels";
import ChannelStreamUtil from './../../utils/ChannelStreamUtil';
import ChannelSingleton from '../../components/Epg/ChannelsSingleton';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import store from '../../store'
import logger from 'src/utils/logger/logger';

let channelBlockedIntervalId = null;
let channelBlockedIntervalMs = (PinUtil.getIntervalSecondsForBlockedChannels() * 1000);
const blockedChannels = new BlockedChannels();
const blockedChannelsListener = [];

const blockedChannelsList = () => {
    const {pin_channel = null} = store.getState().pinCodes
    if(pin_channel){
        const blockedChannelsError = pin_channel.info ? pin_channel.info : []
        channelBlockedUtil.set('blockedChannels', blockedChannelsError)
        return blockedChannelsError
    }
    return []
};

const useChannelRatingFlow = function () {
    return PinUtil.useChannelRatingFlow();
};

const usePinRequest = function () {
    return PinUtil.usePinRequest();
};

const updateStatusControlPin = function () {
    return new Promise((resolve, reject) => {
        blockedChannels.checkBlockedChannels().then(
            (blockedChannels) => {
                // Actualizar estructura en memoria con la lista de bloqueados
                channelBlockedUtil.set('blockedChannels', blockedChannels);
                resolve(blockedChannels);
            }
        ).catch(
            (err) => {
                const blockedChannelsError = blockedChannelsList()
                logger.error(err);
                reject(blockedChannelsError);
            }
        );
    });
};

const runChannelBlockedListeners = function(blockedChannels) {
    for (var i = 0, len = blockedChannelsListener.length; i < len; i++) {
        if (blockedChannelsListener[i]) {
            //console.log('[AAF BLOCKED CHANNELS] Running listener de blockedChannels con ' + JSON.stringify(blockedChannels));
            blockedChannelsListener[i](blockedChannels);
        }
    }
}

const startLoopRefreshBlockedChannels = function () {
    if (!useChannelRatingFlow()) {
        return false;
    }
    if (channelBlockedIntervalId) {
        return true;
    }

    // Taer el interval directo, para no esperar si es async o sync el render de App con el import de este modulo
    channelBlockedIntervalMs = PinUtil.getIntervalSecondsForBlockedChannels() * 1000;

    channelBlockedIntervalId = setInterval(
        function () {
            //console.log('[AAF_FWK] Pin > Main > dentro del loop', new Date());
            updateStatusControlPin().then((blockedChannels) => {
                runChannelBlockedListeners(blockedChannels);
            }).catch(
                (e) => {
                }
            );

        }, channelBlockedIntervalMs
    );

    return true;
};

const restartLoopRefreshBlockedChannels = function () {
    if (channelBlockedIntervalId) {
        clearInterval(channelBlockedIntervalId);
        channelBlockedIntervalId = null;
    }
    startLoopRefreshBlockedChannels();
};

/**
 *
 * @param {*} channel_id es el group_id (o service_id ¿?)
 */
const isBlockedChannelById = function (channel_id) {
    let blockedChannelsArray;
    const {pin_channel = null} = store.getState().pinCodes

    if(pin_channel){
      blockedChannelsArray= pin_channel.info ? pin_channel.info : []
    }else{
      blockedChannelsArray = channelBlockedUtil.get('blockedChannels') || [];
    }

    return (Array.isArray(blockedChannelsArray) && blockedChannelsArray.length > 0 && blockedChannelsArray.indexOf(channel_id) >= 0);
};

/**
 *
 * @param {*} channel_id es el group_id (o service_id ¿?)
 */
const isCriticalChannelById = function (channel_id) {
    let _isCriticalChannel = false;
    const channelInfo = ChannelStreamUtil.get(channel_id);
    //console.log('[AAF_FWK] unde: ', (typeof channelInfo === 'undefined' ? 'UNDEFINED' : 'CON VALOR') );
    if(channelInfo) {
        let parental_id = channelInfo.rating && channelInfo.rating.id;     // por ej.: 10
        let parental_code = channelInfo.rating && channelInfo.rating.code; // por ej.: 'G'
        //console.log('[AAF_FWK] Pin > main > isCriticalChannelById ', channel_id, channelInfo.rating);
        // Aquí verificar el parental rating del canal
        // ... ... ...
        // ... ... ...
    }

    // Por el momento ninguno es critical ¡¡ !!
    return _isCriticalChannel;
};

const getChannelOption = async function(excludeGroupId) {
    let optionChannel = null;
    let _optionChannel = DeviceStorage.getItem("previousChannel");
    if(_optionChannel && (_optionChannel != excludeGroupId) ) {
        //console.log('[AAF_FWK2] en AAF Pin has previousChannel: ' + _optionChannel + ', pero el exclude es ' + excludeGroupId);
        if(ChannelSingleton.canPlayChannel(_optionChannel) && !isBlockedChannelById(_optionChannel)) {
            optionChannel = _optionChannel;
        }
    }

    // Si no se resolvió arriba se busca en linealchannels
    if(!optionChannel) {
        //console.log('[AAF_FWK2] en AAF Pin hay last channel pero es nulo?');
        let channels = await new ChannelSingleton().getChannels();
        if(Array.isArray(channels) && channels.length > 0) {
            for(var i = 0; i<channels.length; i++){
                if(ChannelSingleton.canPlayChannel(channels[i].group_id)){
                    if(channels[i].group_id != excludeGroupId) {
                        if(!isBlockedChannelById(channels[i].group_id)) {
                            optionChannel = channels[i].group_id;
                            break;
                        }
                    }
                }
            }
        }
    }
    logger.debug('[AAF BLOCKED CHANNELS] AAF.Pin.getChannelOption, resolved group_id: ' + optionChannel);

    return optionChannel;
}

const getCriticalChannelRating = function () {
    return PinUtil.getCriticalChannelRating();
};

/**
 * FIXME. implementar unregister
 * @param {*} listener
 */
const registerBlockedChannelsListener = function(listener) {
    blockedChannelsListener.push(listener);
};

/**
 * Export module
 */
const Pin = {
  updateStatusControlPin: updateStatusControlPin,
  startLoopRefreshBlockedChannels: startLoopRefreshBlockedChannels,
  restartLoopRefreshBlockedChannels: restartLoopRefreshBlockedChannels,
  useChannelRatingFlow: useChannelRatingFlow,
  usePinRequest: usePinRequest,
  isBlockedChannelById: isBlockedChannelById,
  isCriticalChannelById: isCriticalChannelById,
  getCriticalChannelRating: getCriticalChannelRating,
  getChannelOption: getChannelOption,
  registerBlockedChannelsListener: registerBlockedChannelsListener,
  handleDataPinCodesSuccess: PinUtil.handleDataPinCodesSuccess,
  handleDataPinCodesError: PinUtil.handleDataPinCodesError,
  blockedChannelsList,
};

export { Pin };



// WEBPACK FOOTER //
// ./src/AAF/Pin/main.js